<template>

    <div class="app-container">
        <el-form :rules="rules" ref="form" :model="searchRequery" label-width="120px" class="event-form">

            <!-- 标题 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="标题" prop='title'>
                        <el-input v-model="searchRequery.title" placeholder="请输入标题"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 应用 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="应用" prop="app">
                        <el-select
                        v-model="searchRequery.app"
                        clearable
                        :remote-method="query => this.remoteMethodApp(query, 'app')"
                        :loading="loading"
                        filterable
                        remote
                        @change='getTag'
                        placeholder="请输入应用关键字">
                            <el-option v-for="item in sreach.app" :key="item.app_id" :label="item.app_name" :value="item.app_id"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 发布环境 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="发布环境" prop="env">
                        <el-select v-model="searchRequery.env" clearable placeholder="请选择发布环境">
                            <el-option v-for="item in env" :key="item.id" :label="item.cname" :value="item.default" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 发布方式 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="发布方式">
                        <el-radio-group v-model="searchRequery.method_type" @change='changeMethod'>
                            <el-radio label="tag">tag发布</el-radio>
                            <el-radio label="branch">分支发布</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 选取tag -->
            <el-row v-if='searchRequery.method_type === "tag"'>
                <el-col :span="24">
                     <el-form-item :label='"选取tag"'  prop='method_value'>
                        <el-select
                        v-model="searchRequery.method_value"
                        :remote-method="query => this.remoteMethod(query, searchRequery.method_type)"
                        :loading="loading"
                        filterable
                        allow-create
                        remote
                        clearable
                         :disabled='flag'
                        placeholder="请输入tag">
                            <el-option
                            v-for="(item, index) in sreach[searchRequery.method_type]"
                            :key="index"
                            :label="item"
                            :value="item"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 分支发布 -->
            <el-row v-if='searchRequery.method_type === "branch"'>
                <el-col :span="24">
                     <el-form-item :label='"分支发布"'  prop='method_value'>
                        <el-select
                        v-model="searchRequery.method_value"
                        :remote-method="query => this.remoteMethod(query, searchRequery.method_type)"
                        :loading="loading"
                        filterable
                        remote
                        clearable
                         :disabled='flag'
                        placeholder="请输入分支">
                            <el-option
                            v-for="(item, index) in sreach[searchRequery.method_type]"
                            :key="index"
                            :label="item"
                            :value="item"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 发布的主机 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="发布的主机">
                        <el-radio-group v-model="searchRequery.target_type">
                            <el-radio label="group_name">组名</el-radio>
                            <el-radio label="server_list">主机列表</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 组名 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="组名"  v-if='searchRequery.target_type === "group_name"' prop="target_value">

                        <el-select
                        v-model="searchRequery.target_value"
                        :remote-method="query => this.remoteMethod(query, searchRequery.target_type)"
                        :loading="loading" filterable remote clearable placeholder="请填写组名">
                            <el-option
                            v-for="(item, index) in sreach[searchRequery.target_type]"
                            :key="index" :label="item" :value="item" />
                        </el-select>

                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 主机列表 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="主机列表" v-if='searchRequery.target_type === "server_list"' prop="target_list">

                        <el-select
                        v-model="searchRequery.target_list"
                        :remote-method="query => this.remoteMethod(query, searchRequery.target_type)"
                        :loading="loading" filterable remote multiple reserve-keyword placeholder="请填写主机列表">
                            <el-option
                            v-for="(item, index) in sreach[searchRequery.target_type]"
                            :key="index" :label="item.host_name" :value="item.ip"/>
                        </el-select>

                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 附件 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件">
                        <a href="javascript:;" class="file">选择文件  
                            <input class="input_file" type="file" @change="changeFn">  
                        </a>
                        <div v-if="searchRequery.annex.length>0">
                            <div v-for="(item, index) in searchRequery.annex" :key="index">{{item.name}}</div>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 备注 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注">
                        <el-input type='textarea' v-model="searchRequery.describe"/>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit('form')">立即提交</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>

</template>

<script>
    import services from './cicd.services'
    import { getRules } from './cicd.rules'

    const rules = getRules()

    export default {
        props: {
            callback: Function
        },

        data() {
            return {
                searchRequery: {
                    annex: [],
                    target_type: 'group_name',
                    method_type: 'tag',
                    doUpload: '/cicd/deployNew'
                },
                rules: rules,
                sreach: {},
                search_criteria: {},
                flag: true,
                loading: false,
                loadings: false
            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            env() {
                return this.dictionary.env
            }

        },

        mounted() {
            services.createSearch().then(
                res =>{
                    this.search_criteria = {
                        ...res,
                        app: res.apps,
                        envs: res.envs,
                        group_name: res.groups,
                        server_list: res.servers
                    }
                },
                err => this.$message.error(err.message)
            )
        },

        methods: {
            // 请求搜索
            remoteMethod (query, title) {
                if (query !== '') {
                    this.loading = true
                    setTimeout(() => {
                        this.loading = false
                        this.sreach[title] = this.search_criteria[title] && this.search_criteria[title].filter(item => {
                            
                            if(typeof(item) === 'string') {
                                return item.toLowerCase().includes(query.toLowerCase());
                            }else {
                                return item.host_name.toLowerCase().includes(query.toLowerCase()) || item.ip.toLowerCase().includes(query.toLowerCase())
                            }
                        });
                    }, 200);
                } else {
                    this.sreach[title] = [];
                }
            },
            remoteMethodApp(query) {
                if (query !== '') {
                    this.loading = true
                    setTimeout(() => {
                        this.loading = false
                        this.sreach.app = this.search_criteria.app && this.search_criteria.app.filter(item => {
                                return item.app_name.toLowerCase().includes(query.toLowerCase());
                            
                        });
                    }, 200);
                } else {
                    this.sreach.app = [];
                }
            },
            
            // 上传文件
            changeFn(e){
                let files = e.target.files || e.dataTransfer.files
                let params = {
                    file_name : files[0]
                };
                services.upload(params).then(res => {
                    let fileData={}
                    fileData.name=res.file_data.file_name;
                    fileData.url=res.file_data.download_url;
                    this.searchRequery.annex.push(fileData)
                    this.$message.success("导入成功");
                }).catch(err => {
                    this.$message.error(err.message)

                })
            },

            // 获取远程tag列表
            getTag() {
                this.flag = true
                this.searchRequery.app && services.gitlabSearch({ app_id: this.searchRequery.app }).then(
                    res => {
                        this.search_criteria = {
                            ...this.search_criteria,
                            tag: res.tags,
                            branch: res.branches
                        }
                        this.flag = false
                    },
                    err => this.$message.error(err.message)
                )
            },

            // 选取发布方式
            changeMethod(type) {
                this.sreach[this.searchRequery.method_type] = []
                this.searchRequery.method_Value = ''
            },

            // 点击取消跳转
            onCancel() {
                this.$modal.close()
            },

            // 编辑提交参数
            getParams() {
                return {
                    title: this.searchRequery.title,
                    app: this.searchRequery.app,
                    user_name: localStorage.getItem('internalUserid'),
                    user_cn_name: localStorage.getItem('name'),
                    env: this.searchRequery.env,
                    method_type: this.searchRequery.method_type,
                    method_value: this.searchRequery.method_value,
                    target_type: this.searchRequery.target_type,
                    target_value: this.searchRequery.target_type === 'group_name' ? this.searchRequery.target_value : this.searchRequery.target_list,
                    annex: this.searchRequery.annex,
                    describe: this.searchRequery.describe
                }
            },

            // 点击提交按钮
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        let params = this.getParams()
                        services.deployCreate(params)
                            .then(res => {
                                this.$message.success('部署单创建成功')
                                if (typeof(res.id) === 'number') {
                                    let params = {
                                        "deploy_id": res.id,
                                        "user_name": localStorage.getItem('internalUserid')
                                    }
                                    services.deployRun(params)
                                        .then(() => this.$message.success('正在执行部署单'))
                                        .catch(err => this.$message.errpr(err.message))
                                }    
                            })
                            .catch(err => this.$message.errpr(err.message))
                            .finally(() => {
                                this.$modal.close()
                                loading.close()
                                this.callback()
                            })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-form {
        width: 500px;
        /deep/ .el-form-item__content {
            width: 100%;
            div {
                width: 100%;
            }
        }
    }
    .file {
        position: relative;
        display: inline-block;
        background: #409EFF;
        border: 1px solid #409EFF;
        border-radius: 4px;
        padding: 4px 12px;
        overflow: hidden;
        color: #fff;
        text-decoration: none;
        text-indent: 0;
        line-height: 16px;
    }
    .file input {
        position: absolute;
        right: 0;
        top: 0;
        opacity: 0;
    }
</style>
